import { getFormattedTime } from 'helpers/time-format'
import { TRAILER_TITLE } from 'constant'
import { CYCLE_CHANGE_REGEXP } from './constants'

export const getServicesDisplayNames = ({ servicesList = [], catalogRefIds = []} = {}) => {
  const lastListIndex = catalogRefIds.length - 1

  return catalogRefIds.reduce((acc, id, index) => (
    acc.concat(`${servicesList ? servicesList[id] : ''}${index < lastListIndex ? ', ' : ' '}`)
  ), '')
}

export const getSelectedVehicle = ({ vehicles = [], activeVehicleId = [], isTrailer }) =>
  isTrailer ? TRAILER_TITLE :
    (vehicles.filter(({ userVehicleId }) =>
      userVehicleId === activeVehicleId)[0] || {}).vehicleNickname

export const getSelectedTime = ({ date, time: { displayName, value } = {}} = {}) =>
  displayName && value ? {
    selectedDateTime:
      `${value.match(CYCLE_CHANGE_REGEXP) ? value.toLowerCase() : displayName.toLowerCase()}, ${getFormattedTime(date)}`
  } : {}
